'use client';

import { memo, startTransition } from 'react';
import styled from 'styled-components';
import {
  SearchFieldWithI18n,
  type SearchFieldWithI18nProps,
} from '@frameio/shared/components/SearchField';
import { noop, useSheetInitialFocusRef } from '@frameio/vapor';
import TEXT from './generated/TEXT/ProjectSwitcherSheetSearch';

TEXT.DEFINE({
  /** Placeholder text for the project search field in the project switcher sheet */
  placeholder: 'Search projects',
});

type ProjectSwitcherSheetSearchProps = Pick<
  SearchFieldWithI18nProps,
  | 'aria-activedescendant'
  | 'onQueryChange'
  | 'onKeyDown'
  | 'onBlur'
  | 'onRequestSearch'
  | 'debounce'
>;

export const ProjectSwitcherSheetSearch = memo(
  (props: ProjectSwitcherSheetSearchProps) => {
    const ref = useSheetInitialFocusRef();

    return (
      <SheetSearchForm onSubmit={(e) => e.preventDefault()} role="search">
        <SearchFieldWithI18n
          ref={ref}
          aria-activedescendant={props['aria-activedescendant']}
          aria-autocomplete="list"
          aria-controls="search-list"
          aria-readonly={true}
          autoFocus={true}
          debounce={props?.debounce ?? 0}
          enableSpinner={false}
          onBlur={props.onBlur}
          onKeyDown={props.onKeyDown}
          onQueryChange={(value) => {
            startTransition(() => {
              props.onQueryChange?.(value);
            });
          }}
          onRequestSearch={props?.onRequestSearch ?? noop}
          placeholder={TEXT.placeholder}
        />
      </SheetSearchForm>
    );
  }
);

const SheetSearchForm = styled.form`
  width: 100%;
`;
